import React from 'react'
import PropTypes from 'prop-types'
import Spinner from '../common/Spinner';
import * as XLSX from 'xlsx';
import { Document, Packer, Table, TableRow, TableCell, Paragraph, TextRun, WidthType, AlignmentType, VerticalAlign, convertMillimetersToTwip } from 'docx';
import { saveAs } from 'file-saver';
import ReportButtons from 'components/common/ReportButtons'

const Report10 = ({ tableData, refresh, title }) => {
  const valueConvert = (val) => {
    if(typeof val === typeof 1) return (Number(val).toFixed(2)).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".",",")
    return val
  }

  const getTableRow = (values, format={}) => {
    let row = []
    values.forEach( (val, i) => {
      row.push(new TableCell({
        children: [
          new Paragraph({
            children: [new TextRun({ 
              text: String(val), 
              font:'Calibri', 
              bold: format.bold, 
              color: format.textColor,
              size: format.size,
              allCaps: format.allCaps
            })],
            alignment: format.align[i]
          })
        ],
        verticalAlign: VerticalAlign.CENTER,
        shading: {
          fill: format.backgroundColor
        },
        margins: {
          marginUnitType: WidthType.DXA,
          top: 100, bottom: 100, left: 100, right: 100
        }
      }))
    })
    return row
  }
  
  const downloadDoc = () => {
    //TABLE
    let rows = []
    const headerStyle = {
      bold: true, backgroundColor:'#b6b6b6', textColor: 'white', size: '22', allCaps: true,
      align: Array(5).fill(AlignmentType.CENTER)
    }
    const bodyStyle = {
      bold: false, backgroundColor:'#f4f4f4', textColor: 'black', size: '24', allCaps: false,
      align: Array(2).fill(AlignmentType.LEFT).concat(Array(3).fill(AlignmentType.RIGHT))
    }
    //header
    rows.push(new TableRow({
      children: getTableRow([
        'Kod procedury',
        'Nazwa procedury',
        'Liczba wykonanych procedur',
        'Jednostkowy koszt normatywny procedury [zł]',
        'Jednostkowy koszt wytworzenia procedury [zł]'
      ], headerStyle),
      tableHeader: true
    }))
    //body
    tableData.map((item, i) => {
      rows.push(new TableRow({
        children: getTableRow([
          item.code,
          item.name,
          item.liczba_proc_us,
          valueConvert(item.jedn_norm),
          valueConvert(item.jedn_koszt)
        ], bodyStyle)
      }))
    })

    let table = new Table({
      rows: rows,
      width: { size: 100, type: WidthType.PERCENTAGE}
    })

    //DOCUMENT
    let paragraphs = [
      new Paragraph({
        children:[
          new TextRun({text: title+'\n\n', font:'Calibri', bold: true, size: 26 })
        ],
        alignment: AlignmentType.JUSTIFIED,
        spacing: { after: 200 }
      }),
      table
    ]

    let doc = new Document({ 
      sections: [{
        properties: { page: { 
          margin: {
              top: convertMillimetersToTwip(15),
              right: convertMillimetersToTwip(15),
              bottom: convertMillimetersToTwip(15),
              left: convertMillimetersToTwip(15),
          },
        }},
        children: paragraphs
      }] 
    })

    // doc.Settings.addCompatibility().doNotExpandShiftReturn();

    Packer.toBlob(doc).then(blob =>{
      saveAs(blob, title+'.doc')
    })
  }
  const downloadXlsx = () =>{
    var wb = XLSX.utils.table_to_book(document.getElementById('tabela10'), {sheet:"Koszty norm., wytw.", raw:true});
    var wbout = XLSX.write(wb, {bookType:'xlsx', bookSST:true, type: 'binary'});
    let filename = title+'.xlsx';
    saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), filename);
  }
  const s2ab = (s)=>{
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
  }
  const downloadCSV = () =>{
    let filename = title+'.csv';
    var csv = [];
    var rows = document.querySelectorAll(`#tabela10 tr`);
    
    for (var i = 0; i < rows.length; i++) {
        var row = [], cols = rows[i].querySelectorAll("td, th");
        
        for (var j = 0; j < cols.length; j++) 
            // row.push(cols[j].innerText.replace(",","."));
            row.push(cols[j].innerText);
        
        csv.push(row.join(";"));		}
        csv = csv.join("\n")

    var csvFile;
    var downloadLink;
    // CSV FILE
    var universalBOM = "\uFEFF";
    csvFile = new Blob(['\ufeff',csv], {type: "text/csv;charset=UTF-8"});
    // Download link
    downloadLink = document.createElement("a");
    // File name
    downloadLink.download = filename;
    // We have to create a link to the file
    downloadLink.href = window.URL.createObjectURL(csvFile);
    // Make sure that the link is not displayed
    downloadLink.style.display = "none";
    // Add the link to your DOM
    document.body.appendChild(downloadLink);
    // Lanzamos
    downloadLink.click();
  }

  if(tableData){
    return (<>
     <ReportButtons downloadDoc={downloadDoc} downloadCSV={downloadCSV} downloadXlsx={downloadXlsx} />
      <table className='table table-border tableRaporty' id='tabela10'>
        <thead className='headerColor'>
          <tr>
            <th>Kod procedury</th>
            <th>Nazwa procedury</th>
            <th>Liczba wykonanych procedur</th>
            <th>Jednostkowy koszt normatywny procedury [zł]</th>
            <th>Jednostkowy koszt wytworzenia procedury [zł]</th>
          </tr>
        </thead>
        <tbody className=''>
          {tableData.map((item, i) => {
            return (<tr key={`rep2-${i}`} className='tryColor'>
              <td className='' key={`rep2-${i}-code`}>{(item.code)}</td>
              <td className='' key={`rep2-${i}-name`}>{(item.name)}</td>
              <td className='rightAlignCell' key={`rep2-${i}-liczba_proc_us`}>{(item.liczba_proc_us)}</td>
              <td className='rightAlignCell' key={`rep2-${i}-jedn_norm`}>{valueConvert(item.jedn_norm)}</td>
              <td className='rightAlignCell' key={`rep2-${i}-jedn_koszt`}>{valueConvert(item.jedn_koszt)}</td>
            </tr>)
          })}
        </tbody>
      </table>
    </>)
  }else{
    return <Spinner />
  }
}
Report10.propTypes = {
  tableData: PropTypes.object,
  refresh: PropTypes.bool.isRequired,
}
export default Report10
